import { Component, Inject } from '@angular/core';
import { ServiceInfoClientService } from '../../../service/service-info-client.service';
import Swal from 'sweetalert2';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DealsActionData, TagsRequestResponse } from 'src/app/pages/dashboards/clients/interface/data.interface';

@Component({
  selector: 'app-modal-edit-tags-deals',
  templateUrl: './modal-edit-tags-deals.component.html',
  styleUrl: './modal-edit-tags-deals.component.scss'
})
export class ModalEditTagsDealsComponent {
  public requestPutTags: TagsRequestResponse;
  public dataDeal: DealsActionData;
  public tagsDeal: string[] = [];
  public tags: string[] = [];
  public currentTag: string = '';
  public separatorKeysCodes: number[] = [13, 188];

  constructor(private infoService: ServiceInfoClientService, private dialogRef: MatDialogRef<ModalEditTagsDealsComponent>, @Inject(MAT_DIALOG_DATA)public data: any) {
    this.dataDeal = data;
    this.tagsDeal = Array.isArray(data.actions.tags) ? data.actions.tags : [];
  }

  ngOnInit() {
    this.getDealsTags();
  }

  public getDealsTags() {
    this.infoService.getDealsTags().subscribe({
      next: (res: string[]) => {
        this.tags = res;
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  public filteredTags(): string[] {
    return Array.isArray(this.tags) ? this.tags.filter(tag => !this.tagsDeal.includes(tag)) : [];
  }

  add(event: any): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.tagsDeal.push(value.trim());
    }

    if (input) {
      input.value = '';
    }

    this.currentTag = '';
  }

  remove(tag: string): void {
    const index = this.tagsDeal.indexOf(tag);

    if (index >= 0) {
      this.tagsDeal.splice(index, 1);
    }
  }

  selected(event: any): void {
    if (!this.tagsDeal.includes(event.option.viewValue)) {
      this.tagsDeal.push(event.option.viewValue);
    }
    this.currentTag = '';
  }

  public updateTagsDeal() {
    this.requestPutTags = {
      dealId: this.dataDeal.dealId,
      dealActionId: this.dataDeal.actions.id,
      tags: this.tagsDeal
    }

    this.infoService.putDealTags(this.requestPutTags).subscribe({
      next: (res: string[]) => {
        this.tags = res;
        this.dialogRef.close(res);
      },
      error: (err) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          text: err.error
        });
      }
    });
  }

}